import { Link } from "react-router-dom"
import NominationRequestForm from "../components/NominationRequestForm"
import "./NominationPage.css"

function NominationPage() {
  return (
    <div className="nomination-page">
      <Link to="/" className="back-link">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Back to Home
      </Link>

      <div className="page-header">
        <h1>Nominate Goosnargh Pharmacy</h1>
      </div>

      <div className="info-box">
        <h2>What is a Pharmacy Nomination?</h2>
        <ul>
          <li>Nominating a pharmacy means your GP will send your prescriptions directly to us electronically.</li>
          <li>We will register your nomination with your GP surgery on your behalf.</li>
          <li>You will receive a confirmation email once your nomination has been processed.</li>
          <li>You can change your nominated pharmacy at any time.</li>
          <li>If you have any questions, please contact our pharmacy team on 01772 865238.</li>
        </ul>
      </div>

      <div className="form-section">
        <h2>Complete the Nomination Form</h2>
        <p>
          Fill in the form below and we'll handle the registration with your GP surgery.
        </p>
      </div>

      <div className="form-container">
        <NominationRequestForm />
      </div>
    </div>
  )
}

export default NominationPage
